import React, { useEffect } from 'react'

const Demo = ({url}) => {
  useEffect(()=>{
    window.location = url;
  });
  return (
    <section>Redirecting...</section>
  )
}

export default Demo
